module.exports = __webpack_public_path__ + "static/media/updateYourDetails.b304cf10.png";